import React, { useState } from "react"
import styles from "./Expandable.module.css"
import { Icon } from "frontend/components/icons"
import { Heading } from "frontend/components/text"
import { handleClickViaKeyboard } from "frontend/utils/a11y"

const Expandable = ({ children, label, labelWhenExpanded, labelWhenHidden, className }) => {
  const [isExpanded, setExpanded] = useState(false)

  const toggleExpansion = () => {
    setExpanded(!isExpanded)
  }

  const getLabel = () => {
    if (isExpanded) {
      return labelWhenExpanded || label
    } else {
      return labelWhenHidden || label
    }
  }

  return (
    <div className={className}>
      <span className={styles.toggle} onClick={toggleExpansion} onKeyPress={handleClickViaKeyboard(toggleExpansion)}>
        <Heading size={5} className={styles.heading}>
          {getLabel()}
        </Heading>
        <Icon className={styles.icon} ariaLabel={getLabel()} name={isExpanded ? "caret-up" : "caret-down"} />
      </span>
      <div className={styles.expandable} style={isExpanded ? { height: "auto" } : { height: 0 }}>
        {isExpanded && children}
      </div>
    </div>
  )
}

export default Expandable
